import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { BanksList } from "./BanksList";
import { QRModal } from "./QRModal";
export var SBPModal = function SBPModal(props) {
  if (props.type === 'qr') return /*#__PURE__*/React.createElement(QRModal, _extends({}, props, {
    "data-t-id": "Popups-SBPModal"
  }));
  if (props.type === 'bank-list') return /*#__PURE__*/React.createElement(BanksList, props);
  return null;
};